import { render } from "./LearningHubCourse.vue?vue&type=template&id=08e160c1"
import script from "./LearningHubCourse.vue?vue&type=script&lang=js"
export * from "./LearningHubCourse.vue?vue&type=script&lang=js"

import "./LearningHubCourse.vue?vue&type=style&index=0&id=08e160c1&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__